// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ICyLZ","title":"Header_title__Rftah","left":"Header_left__3O1uS","clinicName":"Header_clinicName__3COin"};